import script from "./ProfileThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileThumb.vue?vue&type=script&setup=true&lang=js"

import "./ProfileThumb.vue?vue&type=style&index=0&id=c9f0d092&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9f0d092"]])

export default __exports__